import { render } from "./legal.vue?vue&type=template&id=0f49a085&scoped=true"
import script from "./legal.vue?vue&type=script&lang=js"
export * from "./legal.vue?vue&type=script&lang=js"

import "./legal.vue?vue&type=style&index=0&id=0f49a085&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/funfindhk20250610/front-vue-src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f49a085"]])

export default __exports__